import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const ConfigContext = createContext(null);

// URL del API (esta es la única variable que se mantiene en el frontend)
const API_URL = process.env.REACT_APP_API_URL;

// Intervalo de refresco: 10 minutos (en milisegundos)
const CONFIG_REFRESH_INTERVAL_MS = 10 * 60 * 1000;

// Valores por defecto mientras carga la configuración
const defaultConfig = {
  fotosUrl: "",
  fotos360Url: "",
  fotoNd: "",
  turnstileSiteKey: "",
  googleMapsUrl: "",
  syncfusionLicense: "",
};

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(defaultConfig);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchConfig = useCallback(async (isInitialLoad = false) => {
    try {
      const response = await axios.get(`${API_URL}/config`);
      if (response.data.status === "success") {
        setConfig(response.data.result);
      } else if (isInitialLoad) {
        setError("Error al cargar configuración");
      }
    } catch (err) {
      if (isInitialLoad) {
        console.error("Error fetching config:", err);
        setError(err.message);
      }
    } finally {
      if (isInitialLoad) {
        setIsLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    // Carga inicial
    fetchConfig(true);

    // Refresco automático cada 10 minutos
    const intervalId = setInterval(() => {
      fetchConfig(false);
    }, CONFIG_REFRESH_INTERVAL_MS);

    return () => clearInterval(intervalId);
  }, [fetchConfig]);

  const value = {
    ...config,
    apiUrl: API_URL,
    isLoading,
    error,
  };

  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  );
}

export function useConfig() {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfig debe usarse dentro de un ConfigProvider");
  }
  return context;
}

export default ConfigContext;
